import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_4 = { class: "ui-button-content" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Adicionar")
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "ui-table"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ui-row header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-22 ant-col-xl-17 ui-cell" }, " Valor "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell" }, " Status "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-align-center" }, " Ações ")
], -1)
const _hoisted_10 = { class: "ui-rows ui-rolagem-padrao" }
const _hoisted_11 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-17 ui-cell",
  "data-title": "Valor"
}
const _hoisted_12 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell",
  "data-title": "Status"
}
const _hoisted_13 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-actions-table",
  "data-title": "Ações"
}
const _hoisted_14 = { class: "ui-actions" }
const _hoisted_15 = { class: "ui-action ui-move" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Cancelar")
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Confirmar")
], -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "ant-row" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Adicionar")
], -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "ui-table"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ui-row header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-22 ant-col-xl-17 ui-cell" }, " Valor "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell" }, " Ativo "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-align-center" }, " Ações ")
], -1)
const _hoisted_29 = { class: "ui-rows ui-rolagem-padrao" }
const _hoisted_30 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-17 ui-cell",
  "data-title": "Valor"
}
const _hoisted_31 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell",
  "data-title": "Ativo"
}
const _hoisted_32 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-actions-table",
  "data-title": "Ações"
}
const _hoisted_33 = { class: "ui-actions" }
const _hoisted_34 = { class: "ui-action ui-move" }
const _hoisted_35 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_icone = _resolveComponent("icone")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_a_form_item, { label: "Novo valor" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  ref: "campoNovoValorItem",
                  type: "text",
                  class: "ant-input",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.novoValor) = $event)),
                  onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.apresentarNovosSubItensCaracteristica()), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.state.novoValor]
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_form_item, { label: " " }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  class: "ui-button -second ui-mh-32 ui-full",
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.apresentarNovosSubItensCaracteristica()))
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", null, [
                      _createVNode(_component_icone, { nome: "editar" }),
                      _createTextVNode(" Subitens")
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_a_form_item, { label: " " }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  class: "ui-button -primary ui-mh-32 ui-full",
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.adicionarItem()))
                }, _hoisted_7)
              ]),
              _: 1
            })
          ])
        ]),
        (_ctx.computedItensListaSubItens.length <= 0)
          ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
              key: 0,
              mensagem: "Nenhum item foi adicionado ainda"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_draggable, {
                  modelValue: _ctx.computedItensListaSubItens,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedItensListaSubItens) = $event)),
                  "item-key": "index",
                  handle: ".ui-move"
                }, {
                  item: _withCtx(({element,index}) => [
                    (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "ant-row ui-row"
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_a_input, {
                          class: "ant-input",
                          value: element.valor,
                          "onUpdate:value": ($event: any) => ((element.valor) = $event),
                          onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.adicionarItem()), ["enter"]))
                        }, null, 8, ["value", "onUpdate:value"])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_selecionar_sim_nao, {
                          valor: element.status,
                          "onUpdate:valor": ($event: any) => ((element.status) = $event)
                        }, null, 8, ["valor", "onUpdate:valor"])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_a_tooltip, { title: "Arraste para cima ou para baixo para ordenar os itens" }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", _hoisted_15, [
                                _createVNode(_component_icone, { nome: "ordenar-lista" })
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tooltip, { title: "Editar Subitens" }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                class: "ui-action",
                                onClick: ($event: any) => (_ctx.apresentarSubItensCaracteristica(index,element))
                              }, [
                                _createVNode(_component_icone, { nome: "editar" })
                              ], 8, _hoisted_16)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_a_tooltip, { title: "Deletar" }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                class: "ui-action",
                                onClick: ($event: any) => (_ctx.removerItem(index))
                              }, [
                                _createVNode(_component_icone, { nome: "excluir" })
                              ], 8, _hoisted_17)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ])
                    ]))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]))
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      width: 800,
      visible: _ctx.state.apresentarSubItems,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.apresentarSubItems) = $event))
    }, {
      title: _withCtx(() => [
        _createTextVNode(" Subitens de: " + _toDisplayString(_ctx.state.valorCaracteristicaItem), 1)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "ui-button -second",
            type: "button",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.ocultarSubItensCaracteristica()))
          }, _hoisted_19),
          _createElementVNode("button", {
            class: "ui-button -primary",
            type: "button",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.confirmarSubItensCaracteristica()))
          }, _hoisted_21)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_a_form_item, { label: "Novo valor" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      ref: "campoNovoValorSubItem",
                      type: "text",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.novoValorSubItem) = $event)),
                      onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => (_ctx.adicionarSubItem()), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.state.novoValorSubItem]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_a_form_item, { label: " " }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      class: "ui-button -primary ui-mh-32 ui-full",
                      type: "button",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.adicionarSubItem()))
                    }, _hoisted_26)
                  ]),
                  _: 1
                })
              ])
            ]),
            (_ctx.state.subItens.length <= 0)
              ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                  key: 0,
                  mensagem: "Nenhum Sub item foi adicionado ainda"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_draggable, {
                      modelValue: _ctx.state.subItens,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.subItens) = $event)),
                      "item-key": "index",
                      handle: ".ui-move"
                    }, {
                      item: _withCtx(({element,index}) => [
                        (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "ant-row ui-row"
                        }, [
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_a_input, {
                              class: "ant-input",
                              value: element.valor,
                              "onUpdate:value": ($event: any) => ((element.valor) = $event)
                            }, null, 8, ["value", "onUpdate:value"])
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_component_selecionar_sim_nao, {
                              valor: element.status,
                              "onUpdate:valor": ($event: any) => ((element.status) = $event)
                            }, null, 8, ["valor", "onUpdate:valor"])
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _createVNode(_component_a_tooltip, { title: "Arraste para cima ou para baixo para ordenar os Sub itens" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("a", _hoisted_34, [
                                    _createVNode(_component_icone, { nome: "ordenar-lista" })
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_tooltip, { title: "Deletar" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("a", {
                                    class: "ui-action",
                                    onClick: ($event: any) => (_ctx.removerSubItem(index))
                                  }, [
                                    _createVNode(_component_icone, { nome: "excluir" })
                                  ], 8, _hoisted_35)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ])
                        ]))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}